module.exports = __webpack_public_path__ + "static/img/inventario_foodgrade.32e5ca3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/inventario_foodgrade.png
// module id = 94
// module chunks = 0